import styles from './GenericButton.module.scss';
import React, { FunctionComponent, ReactElement, useState } from 'react';


export interface IGenericButtonProps {
  buttonText: string;
  handleClick: () => void;
}

const GenericButton: FunctionComponent<IGenericButtonProps> = (props, { buttonText, handleClick, children }) => {
  const [hover, setHover] = useState(false);
  const elements = React.Children.toArray(props.children)

  return (
    <>
      <button
        className={styles.genericButton}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={() => props.handleClick()}
      >
        <span className={`${styles.icon} ${styles.baseline}`}>{React.cloneElement(elements[0] as ReactElement, {hovered: hover})}</span>
        <span className={styles.buttonText}>{props.buttonText}</span>
      </button>
    </>
  );
};

export default GenericButton;
